import React from 'react';

let KEYS = 0;

const createErrorListItemKey = (key: string) =>
  `error_${key
    .toString()
    .slice(0, 20)
    .replace(/[^a-zA-Z0-9]+/, '_')}_${(KEYS += 1)}`.toLowerCase();

const mapErrorList = ({ for: id, text }: { for?: string; text: string }) => {
  const key = createErrorListItemKey(id || text);
  return id ? (
    <label key={key} htmlFor={id}>
      {text}
    </label>
  ) : (
    <span key={key}>{text}</span>
  );
};
type ErrorListProps = {
  errors?: {
    for?: string;
    text: string;
  }[];
  className?: string;
};
const ErrorList: React.FC<ErrorListProps> = ({ errors, className }) => (
  <div className="dialog2--messages">
    <div className={`dialog2--message ${className}`}>
      <div className="form-errors">{errors?.map(mapErrorList)}</div>
    </div>
  </div>
);
ErrorList.defaultProps = {
  className: 'error',
};

export default ErrorList;
